import { render, staticRenderFns } from "./DashboardWidgetRedditivita.vue?vue&type=template&id=1eb99664&"
import script from "./DashboardWidgetRedditivita.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetRedditivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports